import { render, staticRenderFns } from "./BlockAreaV2.vue?vue&type=template&id=96883b76&scoped=true&"
import script from "./BlockAreaV2.vue?vue&type=script&lang=js&"
export * from "./BlockAreaV2.vue?vue&type=script&lang=js&"
import style0 from "./BlockAreaV2.vue?vue&type=style&index=0&id=96883b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96883b76",
  null
  
)

export default component.exports